<template>
  <div class="box">
    <div class="page">
      <div class="subpage">
        <div style="width: 360px; height: 66px; margin: auto">
          <a style="height: auto" href="https://www.gospel-event.com/">
            <img width="360" src="https://gospelapp-b51ce.web.app/img/logo2.f3801afd.png" />
          </a>
        </div>
        <br />
        <br />
        <br />
        <p class="c18">
          <span class="c85 c91"><br /></span>
        </p>
        <div v-if="data.type == 0">
          <p class="c22"><span class="c57">VOUS ÊTES DES PARTICULIERS</span></p>
          <p class="c22">
            <span class="c2">Vos noms et prénoms: {{ data.Nom }} {{ data.Prénom }} </span>
          </p>
          <p class="c22">
            <span class="c2">Votre adresse postale: {{ data.adressePostaleParticulier }} </span>
          </p>

          <p class="c22">
            <span class="c2"
              >Tel fixe&nbsp;et mobiles&nbsp;pour vous joindre: {{ data.telFixe }}
              {{ data.telMob }} {{ data.tel }}</span
            >
          </p>
          <p class="c22">
            <span class="c2"
              >Votre adresse mail principale avec laquelle vous nous avez écrit:
              {{ data.mail }}
            </span>
          </p>
        </div>
        <div v-else>
          <p class="c22">
            <span class="c57">VOUS ÊTES UNE AGENCE OU UNE ENTREPRISE</span>
          </p>
          <p class="c22">
            <span class="c2"
              >Nom de la structure, Siret et code APE:
              {{ data.nomDeLaStructure }}
              {{ data.Siret }}
              {{ data.CodeAPE }}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
            >
          </p>
          <p class="c22">
            <span class="c2"
              >Représentée par (en sa qualité de):
              {{ data.représentant }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
            >
          </p>
          <p class="c22">
            <span class="c2">Adresse postale de correspondance: {{ data.Adresse }}</span>
          </p>
          <p class="c22">
            <span class="c2"
              >Vos numéros de téléphone fixes et mobiles: {{ data.telFixe }} {{ data.telMob }}</span
            >
          </p>
        </div>

        <p class="c22 c62"><span class="c79 c109"></span></p>
        <p class="c22"><span class="c57">LE GROUPE DE GOSPEL</span></p>
        <p class="c22">
          <span class="c2"
            >Nom du groupe de Gospel que vous souhaitez retenir: {{ data.groupe }}
          </span>
        </p>
        <p class="c22">
          <span class="c2"
            >Combien de chanteurs et musiciens souhaités: {{ data.nbChanteurs }}
          </span>
        </p>
        <p class="c22">
          <span class="c35"
            >Tarif de cette formule indiquée sur le devis (déplacements inclus):
            {{ data.tarif }}</span
          >

          <br />
        </p>
        <p class="c22 c62"><span class="c79 c109"></span></p>
        <p class="c22"><span class="c57">LA PRÉPARATION</span></p>

        <p class="c22">
          <span class="c2"
            >Date de la célébration : {{ formatDate(data.date) }}<br />Nom de la ville:
            {{ data.nomVille }}
          </span>
        </p>
        <p class="c16">
          <span class="c2">Code postal de cette commune: {{ data.cp }} </span>
        </p>
        <p class="c16">
          <span class="c2"
            >Type de lieu de la cérémonie (église, funérarium) :
            {{ data.lieuCérémonie }}
          </span>
        </p>
        <p class="c16">
          <span class="c2">Lien Google Maps du lieu de la prestation (important)&nbsp;: </span>
        </p>
        <p class="c16">
          <span class="c2" style="overflow-wrap: break-word">
            <a :href="data.lienGoogleMapslieuCérémonie"> {{ data.lienGoogleMapslieuCérémonie }}</a>
          </span>
        </p>
        <p class="c16">
          <span class="c2"
            >Adresse précise du lieu de la cérémonie (pour vérification) :
            {{ data.AdresselieuCérémonie }}
            <!-- <br />Personne référente (autre que vous) qui recevra un
            SMS pour informer de l’arrivée du groupe&nbsp;: -->
            <!-- <br />Nom-Prénom :
            {{ data.personneRefNomPrenom }}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Tél mobile:
            {{ data.personneRefTel }}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Quel lien familial/amical:
            {{ data.personneRefLien }} &nbsp; -->
          </span>
        </p>
        <p class="c16">
          <span class="c35">Heure&nbsp;précise du début de l’événement </span
          ><span class="c25">(le groupe arrivera 90 min avant) </span
          ><span class="c2"
            >: {{ data.heureDebEven }} &nbsp; <br />Quelle sera la durée de la cérémonie:
            {{ data.dureeCer }}
            <br />Type de cérémonie:
            {{ data.typeCer }}
          </span>
        </p>
        <p class="c16">
          <span class="c2"
            >Tenues souhaitées pour le groupe (toges gospel OU tenues noires de soirée) :
            {{ data.tenues }}
          </span>
        </p>
        <p class="c16">
          <span class="c2">Nombre de personnes attendues: {{ data.nbInvites }} </span>
        </p>
        <p class="c16">
          <span class="c2"
            >Avez-vous d’autres demandes ou suggestions artistiques à proposer au groupe:
            {{ data.autresDemandes }}
          </span>
        </p>
        <br />
        <p class="c22"><span class="c57">PRÉCISIONS POUR LA PRÉPARATION DES ARTISTES</span></p>

        <p class="c22">
          <span class="c2">
            Le chef de chœur souhaiterait mieux connaître qui est cette personne dont nous allons
            célébrer les obsèques. Cela lui permettra de bien préparer les artistes, qui
            comprendront mieux ce que vous vivez :
          </span>
        </p>
        <p class="c22">
          <span class="c2"
            >Nom et prénom de cette personne : {{ data["Nom et prénom du défun"] }}
            <br />
            Qui était-ce dans votre famille (père, mère ? ...) :
            {{ data["position dans la famille"] }}
            <br />
            Dans quelles conditions cette personne vous a quitté :
            {{ data["Dans quelles conditions"] }}
          </span>
        </p>
      </div>
    </div>
    <div class="page">
      <div class="subpage">
        <p class="c20 c39">
          <span class="c69">Conditions générales de vente</span>
        </p>
        <p class="c20 c39"><span class="c2"></span></p>
        <p class="c16">
          <span class="c2"
            >La SARL SAY PRODUCTION (nom de marque GOSPEL EVENT), au capital de 5.000 €, No de Siret
            512 972 803 000 13 , dont le siège est situé au 45 grand rue, 34260
            CEILHES, réalise des prestations de chants Gospel pour cérémonies et concerts. Vous
            pouvez nous joindre au 07 68 88 94 36, ou par mail à
            virginie.gospelevent@icloud.com</span
          >
        </p>
        <br />
        <p class="c20 c39"><span class="c2"></span></p>
        <p class="c16">
          <span class="c2"
            >Dès réception de votre commande, nous la vérifions et nous la transmettons
            immédiatement au coordinateur du groupe que vous souhaitez réserver.</span
          >
        </p>
        <br />

        <p class="c20 c39"><span class="c2"></span></p>
        <p class="c16">
          <span class="c2"
            >Si ce groupe ne peut valider votre bon de commande, celui-ci sera automatiquement
            annulé mais nous pourrons si vous le souhaitez, vous aider à réserver un autre groupe.
            <br /><br />Si le groupe valide, nous vous attestons cela par retour de mail. Ce bon de
            commande sera ensuite signé électroniquement, nous engageant fermement mutuellement pour
            <br /><br />la prestation. La prestation sera composée de maximum 7 chants. Le nombre
            sera notamment déterminé par le plan de messe négocié entre vous et l’officiant. Le
            groupe ne prendra pas en charge les chants religieux en français.</span
          >
        </p>
        <br />

        <p class="c20 c39"><span class="c2"></span></p>
        <p class="c2">
          <span class="c3 c16"
            ><strong>La totalité de votre règlement devra nous parvenir</strong> </span
          ><span class="c2"> par virement sous 72h maximum après la cérémonie. </span>
        </p>

        <p class="c2">
          <span class="c16"
            >Le libellé du virement devra mentionner le numéro de votre facture qui vous sera
            communiqué prochainement.</span
          >
        </p>
        <p class="c16"><span class="c2">Aucun acompte n’est obligatoire.</span></p>
        <p class="c16">
          <span class="c2"
            >Nous vous contacterons par téléphone le lendemain de la cérémonie pour nous assurer de
            votre entière satisfaction. <br /><br />Si l’officiant devait à un moment des
            préparatifs ou de la cérémonie, revoir le nombre de chants ou leur durée, ceci ne
            saurait constituer une condition d’annulation de votre commande. <br /><br />Si à la
            suite de la cérémonie, des amis ou des connaissances demandent le contact du groupe, le
            client s’engage à fournir uniquement le lien du site web Gospel Event :
            www.gospel-event.com <br /><br />Cette commande pourra être annulée de plein droit et
            sans préavis sous réserve d’une entente mutuelle. Autrement vous nous serez redevable
            d’une somme de dédommagement du montant intégral de cette prestation (moins les frais de
            déplacements). <br /><br />En cas de litige portant sur l’interprétation ou
            l’application de cette commande, les parties conviennent de s’en remettre à
            l’appréciation du Tribunal de Montpellie</span
          >
        </p>
        <br />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "pdfToPrint",
  props: ["data"],
  methods: {
    formatDate(date) {
      if (!date) return null;
      var da = new Date(date);
      const [year, month, day] = [
        da.getUTCFullYear(),
        ("0" + (da.getUTCMonth() + 1)).slice(-2),
        ("0" + da.getUTCDate()).slice(-2),
      ];
      return `${day}/${month}/${year}`;
    },
  },
};
</script>
<style type="text/css" scoped>
@import url("https://themes.googleusercontent.com/fonts/css?kit=fpjTOVmNbO4Lz34iLyptLfpjyB5BQourYAyA--No9iX43MHGdcUk8lVDt-hm-NLh");
.lst-kix_list_1-3 > li:before {
  content: "\0025aa  ";
}
.lst-kix_list_1-4 > li:before {
  content: "\01f8ad  ";
}
ul.lst-kix_list_1-0 {
  list-style-type: none;
}
.lst-kix_list_1-7 > li:before {
  content: "\0025aa  ";
}
.lst-kix_list_1-5 > li:before {
  content: "\0025cf  ";
}
.lst-kix_list_1-6 > li:before {
  content: "o  ";
}
ul.lst-kix_list_1-3 {
  list-style-type: none;
}
.lst-kix_list_1-0 > li:before {
  content: "  ";
}
ul.lst-kix_list_1-4 {
  list-style-type: none;
}
.lst-kix_list_1-8 > li:before {
  content: "\01f8ad  ";
}
ul.lst-kix_list_1-1 {
  list-style-type: none;
}
ul.lst-kix_list_1-2 {
  list-style-type: none;
}
ul.lst-kix_list_1-7 {
  list-style-type: none;
}
.lst-kix_list_1-1 > li:before {
  content: "\0025cf  ";
}
.lst-kix_list_1-2 > li:before {
  content: "o  ";
}
ul.lst-kix_list_1-8 {
  list-style-type: none;
}
ul.lst-kix_list_1-5 {
  list-style-type: none;
}
ul.lst-kix_list_1-6 {
  list-style-type: none;
}
ol {
  margin: 0;
  padding: 0;
}
table td,
table th {
  padding: 0;
}
.c65 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: middle;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  background-color: #eeece1;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 61.5pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c42 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: middle;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  background-color: #eeece1;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 64.2pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c49 {
  border-right-style: solid;
  padding: 0pt 5.4pt 0pt 5.4pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  background-color: #eeece1;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 326.1pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c99 {
  border-right-style: solid;
  padding: 0pt 5.4pt 0pt 5.4pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  background-color: #ffffff;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 326.1pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c100 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: middle;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  background-color: #eeece1;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 71.7pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c55 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: middle;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  background-color: #eeece1;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 61.1pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c88 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: middle;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  background-color: #eeece1;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 64.8pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c58 {
  border-right-style: solid;
  padding: 0pt 5.4pt 0pt 5.4pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: middle;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  background-color: #eeece1;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 233.9pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c66 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: middle;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  background-color: #eeece1;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 61.3pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c81 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 324.9pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c50 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 71.7pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c64 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 64.8pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c70 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 71.7pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c8 {
  border-right-style: solid;
  padding: 0pt 5.4pt 0pt 5.4pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 25.6pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c26 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 61.3pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c12 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 61.1pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c98 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 64.8pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c43 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 64.2pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c67 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 61.3pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c40 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 124.2pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c52 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 61.3pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c19 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 64.2pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c56 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 61.5pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c63 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 61.1pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c110 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 71.7pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c71 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 64.8pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c103 {
  border-right-style: solid;
  padding: 0pt 5.4pt 0pt 5.4pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 121pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c106 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 61.5pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c11 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 184pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c30 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 61.3pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c37 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 71.7pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c29 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 64.8pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c36 {
  border-right-style: solid;
  padding: 0pt 5.4pt 0pt 5.4pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: middle;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 276.4pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c97 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 61.1pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c96 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 124.2pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c9 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 124.2pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c107 {
  border-right-style: solid;
  padding: 0pt 5.4pt 0pt 5.4pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 121.2pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c102 {
  border-right-style: solid;
  padding: 0pt 5.4pt 0pt 5.4pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 219.6pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c77 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 61.1pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c7 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 64.2pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c94 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 61.5pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c27 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 0pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 0pt;
  width: 64.2pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c74 {
  border-right-style: solid;
  padding: 0pt 3.5pt 0pt 3.5pt;
  border-bottom-color: #000000;
  border-top-width: 0pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 0pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 124.2pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c0 {
  margin-left: -28.4pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: justify;
  margin-right: -28.4pt;
  height: 5pt;
}
.c8 {
  margin-left: -28.4pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: justify;
  margin-right: -28.4pt;
}
.c115 {
  margin-left: -35.5pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.5;
  orphans: 2;
  widows: 2;
  text-align: center;
  margin-right: -40pt;
}
.c22 {
  margin-left: -21.2pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: justify;
  margin-right: -21.2pt;
}
.c51 {
  color: #000000;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10pt;
  font-family: "Arial";
  font-style: normal;
}
.c18 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: left;
  height: 12pt;
}
.c1 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 12pt;
  font-family: "Calibri";
  font-style: normal;
}
.c31 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 5pt;
  font-family: "Arial";
  font-style: normal;
}
.c75 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10.5pt;
  font-family: "Arial";
  font-style: normal;
}
.c45 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 6pt;
  font-family: "Arial";
  font-style: normal;
}
.c59 {
  color: #365f91;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10pt;
  font-family: "Arial";
  font-style: normal;
}
.c32 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: justify;
  height: 12pt;
}
.c53 {
  color: #366092;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 16pt;
  font-family: "Calibri";
  font-style: normal;
}
.c16 {
  margin-left: -21.3pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: justify;
}
.c73 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 8pt;
  font-family: "Arial";
  font-style: normal;
}
.c21 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10pt;
  font-family: "Calibri";
  font-style: normal;
}
.c2 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10pt;
  font-family: "Arial";
  font-style: normal;
}
.c23 {
  color: #365f91;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10pt;
  font-family: "Arial";
  font-style: normal;
}
.c5 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: center;
  height: 12pt;
}
.c6 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Arial";
  font-style: normal;
}
.c112 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.1500000000000001;
  orphans: 2;
  widows: 2;
  text-align: left;
}
.c33 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.5;
  orphans: 2;
  widows: 2;
  text-align: left;
}
.c15 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: center;
}
.c68 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: justify;
}
.c10 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 2;
  orphans: 2;
  widows: 2;
  text-align: left;
}
.c24 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: left;
}
.c20 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.5;
  orphans: 2;
  widows: 2;
  text-align: center;
}
.c3 {
  vertical-align: baseline;
  font-size: 10pt;
  font-family: "Arial";
  color: #333399;
  font-weight: 400;
}
.c84 {
  color: #4f4f4f;
  font-weight: 400;
  vertical-align: baseline;
  font-size: 4pt;
  font-family: "Arial";
}
.c47 {
  vertical-align: super;
  font-size: 11pt;
  font-family: "Arial";
  color: #000000;
  font-weight: 400;
}
.c44 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.15;
  text-align: left;
  height: 12pt;
}
.c14 {
  vertical-align: baseline;
  font-size: 16pt;
  font-family: "Calibri";
  color: #366092;
  font-weight: 700;
}
.c34 {
  vertical-align: baseline;
  font-size: 10pt;
  font-family: "Calibri";
  color: #000000;
  font-weight: 400;
}
.c4 {
  vertical-align: baseline;
  font-size: 16pt;
  font-family: "Arial";
  color: #365f91;
  font-weight: 700;
}
.c113 {
  color: #365f91;
  font-weight: 400;
  vertical-align: baseline;
  font-size: 16pt;
  font-family: "Arial";
}
.c69 {
  vertical-align: baseline;
  font-size: 15pt;
  font-family: "Arial";
  color: #333399;
  font-weight: 700;
}
.c109 {
  color: #333399;
  font-weight: 400;
  vertical-align: baseline;
  font-size: 4pt;
  font-family: "Arial";
}
.c101 {
  margin-left: -28.4pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  text-align: left;
}
.c57 {
  vertical-align: baseline;
  font-size: 10pt;
  font-family: "Arial";
  color: #333399;
  font-weight: 700;
}
.c48 {
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Arial";
  color: #000000;
  font-weight: 400;
}
.c38 {
  margin-left: -28.4pt;
  border-spacing: 0;
  border-collapse: collapse;
  margin-right: auto;
}
.c89 {
  font-weight: 400;
  vertical-align: baseline;
  font-size: 12pt;
  font-family: "Arial";
}
.c76 {
  vertical-align: baseline;
  font-size: 10pt;
  font-family: "Arial";
  font-weight: 700;
}
.c17 {
  vertical-align: super;
  font-size: 10pt;
  font-family: "Arial";
  font-weight: 400;
}
.c35 {
  vertical-align: baseline;
  font-size: 10pt;
  font-family: "Arial";
  font-weight: 400;
}
.c25 {
  vertical-align: baseline;
  font-size: 9pt;
  font-family: "Arial";
  font-weight: 400;
}
.c41 {
  vertical-align: baseline;
  font-family: "Calibri";
  color: #000000;
  font-weight: 400;
}
.c90 {
  font-weight: 400;
  vertical-align: baseline;
  font-size: 18pt;
  font-family: "Arial";
}
.c86 {
  font-weight: 400;
  vertical-align: baseline;
  font-size: 5pt;
  font-family: "Arial";
}
.c111 {
  font-weight: 400;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Comic Sans MS";
}
.c117 {
  margin-left: -5.4pt;
  border-spacing: 0;
  border-collapse: collapse;
  margin-right: auto;
}
.c61 {
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Arial";
  font-weight: 700;
}
.c72 {
  background-color: #ffffff;
  /* max-width: 453.6pt; */
  padding: 21.3pt 70.8pt 7.1pt 70.8pt;
}
.c85 {
  vertical-align: baseline;
  font-family: "Arial";
  font-weight: 700;
}
.c79 {
  text-decoration: none;
  font-style: normal;
}
.c92 {
  margin-left: -70.9pt;
  margin-right: -70.9pt;
}
.c39 {
  margin-left: -21.3pt;
  margin-right: -21.3pt;
}
.c95 {
  height: 11pt;
}
.c54 {
  height: 31pt;
}
.c93 {
  font-size: 10.5pt;
}
.c87 {
  margin-left: -21.3pt;
}
.c78 {
  height: 29.4pt;
}
.c62 {
  height: 12pt;
}
.c104 {
  height: 20.2pt;
}
.c91 {
  font-size: 6pt;
}
.c108 {
  margin-left: -28.4pt;
}
.c60 {
  color: #ff0000;
}
.c28 {
  height: 15pt;
}
.c83 {
  margin-right: -28.4pt;
}
.c80 {
  height: 27.7pt;
}
.c116 {
  height: 28.1pt;
}
.c46 {
  height: 13.7pt;
}
.c105 {
  margin-right: -21.2pt;
}
.c82 {
  color: #000000;
}
.c114 {
  height: 0pt;
}
.title {
  padding-top: 24pt;
  color: #000000;
  font-weight: 700;
  font-size: 36pt;
  padding-bottom: 6pt;
  font-family: "Times";
  line-height: 1;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
.subtitle {
  padding-top: 18pt;
  color: #666666;
  font-size: 24pt;
  padding-bottom: 4pt;
  font-family: "Georgia";
  line-height: 1;
  page-break-after: avoid;
  font-style: italic;
  orphans: 2;
  widows: 2;
  text-align: left;
}
li {
  color: #000000;
  font-size: 12pt;
  font-family: "Times";
}
p {
  margin: 0;
  color: #000000;
  font-size: 12pt;
  font-family: "Times";
}
h1 {
  padding-top: 24pt;
  color: #000000;
  font-weight: 700;
  font-size: 24pt;
  padding-bottom: 6pt;
  font-family: "Times";
  line-height: 1;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
h2 {
  padding-top: 18pt;
  color: #000000;
  font-weight: 700;
  font-size: 18pt;
  padding-bottom: 4pt;
  font-family: "Times";
  line-height: 1;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
h3 {
  padding-top: 14pt;
  color: #000000;
  font-weight: 700;
  font-size: 14pt;
  padding-bottom: 4pt;
  font-family: "Times";
  line-height: 1;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
h4 {
  padding-top: 12pt;
  color: #000000;
  font-weight: 700;
  font-size: 12pt;
  padding-bottom: 2pt;
  font-family: "Times";
  line-height: 1;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
h5 {
  padding-top: 11pt;
  color: #000000;
  font-weight: 700;
  font-size: 11pt;
  padding-bottom: 2pt;
  font-family: "Times";
  line-height: 1;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
h6 {
  padding-top: 10pt;
  color: #000000;
  font-weight: 700;
  font-size: 10pt;
  padding-bottom: 2pt;
  font-family: "Times";
  line-height: 1;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
body {
  margin: 0;
  padding: 0;
  background-color: #fafafa;
  font: 12pt "Tahoma";
}
* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}
.page {
  width: 21cm;
  height: 29.7cm;
  padding: 10mm;
  margin: 0;
  border: 2px #ffffff solid;
  border-radius: 0px;
  background: rgb(255, 255, 255);
  box-shadow: 0 0 0px rgba(0, 0, 0, 0.1);
}
.text-center {
  text-align: center !important;
}
.text-left {
  text-align: left !important;
}
.v-application {
  font-family: "Roboto", sans-serif;
  line-height: 1.5;
}
.v-input {
  align-items: flex-start;
  display: flex;
  flex: 1 1 auto;
  font-size: 16px;
  letter-spacing: normal;
  max-width: 100%;
  text-align: left;
}
td {
  display: table-cell;
  vertical-align: inherit;
}
tr {
  display: table-row;
  vertical-align: inherit;
  border-color: inherit;
}
thead {
  display: table-header-group;
  vertical-align: middle;
  border-color: inherit;
}

@media print {
  .page {
    clear: both;
    page-break-after: always;
  }
}
.box {
  width: 21cm;
  padding: 0;
  margin: 0;
}
.subpage {
  padding: 0cm 1cm;
  border: 5px rgb(255, 255, 255) solid;
  height: 277mm;
  outline: 1cm #ffffff solid;
}
</style>
